/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import { defineMessages } from 'react-intl'
import {
    AccountIcon,
    LocationIcon,
    ReceiptIcon,
    LockIcon,
    InfoIcon,
    HeartIcon
} from '@salesforce/retail-react-app/app/components/icons'
import { getConfig } from '@salesforce/pwa-kit-runtime/utils/ssr-config'

export const messages = defineMessages({
    orders: { defaultMessage: 'Orders', id: 'global.account.link.order_history' },
    wishlist: { defaultMessage: 'Wishlist', id: 'global.account.link.wishlist' },
    profile: { defaultMessage: 'Personal Information', id: 'global.account.link.account_info' },
    password: { defaultMessage: 'Change Password', id: 'global.account.link.password' },
    addresses: { defaultMessage: 'Address Book', id: 'global.account.link.addresses' },
    payment: { defaultMessage: 'Payment Options', id: 'global.account.link.payment' },
    email: { defaultMessage: 'Communication Preferences', id: 'global.account.communication.preferences' }
})

export const getNavLinks = () => {
    const {app: appConfig} = getConfig()

    return [
        {
            name: 'orders',
            path: '/orders',
            icon: ReceiptIcon
        },
        {
            name: 'wishlist',
            path: '/wishlist',
            icon: HeartIcon
        },
        {
            name: 'profile',
            path: '/personal',
            icon: AccountIcon
        },
        {
            name: 'password',
            path: '/password',
            icon: LockIcon
        },
        {
            name: 'addresses',
            path: '/addresses',
            icon: LocationIcon
        },
        {
            name: 'payment',
            path: '/payment',
            icon: LockIcon
        },
        ...(appConfig.SMS_OPTIN_LOYALTY_ENABLED || appConfig.SFSC_EMAIL_SUBSCRIPTION_ENABLED ? [{
            name: 'email',
            path: '/email',
            icon: InfoIcon
        }] : [])
    ]
}

export const CONFIRMATION_DIALOG_DEFAULT_CONFIG = defineMessages({
    dialogTitle: {
        defaultMessage: 'Confirm Action',
        id: 'confirmation_modal.default.title.confirm_action'
    },
    confirmationMessage: {
        defaultMessage: 'Are you sure you want to continue?',
        id: 'confirmation_modal.default.message.you_want_to_continue'
    },
    primaryActionLabel: { defaultMessage: 'Yes', id: 'confirmation_modal.default.action.yes' },
    primaryActionAriaLabel: {
        defaultMessage: 'Yes, confirm action',
        id: 'confirmation_modal.default.assistive_msg.yes'
    },
    alternateActionLabel: { defaultMessage: 'No', id: 'confirmation_modal.default.action.no' },
    alternateActionAriaLabel: {
        defaultMessage: 'No, cancel action',
        id: 'confirmation_modal.default.assistive_msg.no'
    }
})

export const CREDIT_CARD = 'credit card'
export const PAYPAL = 'paypal'
export const APPLE_PAY = 'applepay'
export const GIFT_CARD = 'smartclixx'
export const BRAND_NAME = 'Garage'
export const CASH = 'cash'

export const ORDER_RAW_STATUS = {
    TRACKING: ['released', 'partially released'],
    STATUS: ['back ordered', 'allocated', 'fulfilled']
}

export const ORDER_RETURN_RAW_STATUS = {
    RETURNED: 'returned',
    PENDING_RETURN: 'pending return'
}

export const ORDER_PRODUCTS_RENDER_MODES = {
    PACKAGES: 'packages',
    ITEMS: 'items'
}

export const SHIPPING_METHODS = {
    PICKUP_IN_STORE: {
      ID: 'pickUpInStore',
      DISPLAY_NAME: 'Pick Up In Store',
      EST_ARRIVAL_TIME: '(Available in 2 hours)'
    }
}

export const RETURNABLE_WINDOW_EXCEEDED_REASON = 'returns.window.exceeded'
export const RETURN_LABEL_URL = 'https://www.royalmail.com/track-my-return#/details/8832'
export const COUNTRY = {
    GB: 'United Kingdom'
}
export const PAYMENT_METHODS = {
    GIFT_CARD: 'gift card'
}
export const DSS = {
    ACTIONS: {
        CANCELLATION: 'cancellation',
        CHANGE_ADDRESS: 'changeaddress',
        TRACKING: 'tracking',
        RETURNS: 'returns'

    },
    SDK_SRC: 'https://cdn.manh.cloud/selfservice/websdk/latest/selfservice.js'
}
